/**
 *  @swagger
 *  definitions:
 *    RegattaPaymentDiscountParams:
 *      type: object
 *      properties:
 *        Name:
 *          description: Name of the RegattaPaymentDiscount
 *          type: string
 *        Value:
 *          description: Value of the RegattaPaymentDiscount
 *          type: integer
 *        Used:
 *          description: Used of the RegattaPaymentDiscount
 *          type: boolean
 *        Content:
 *          description: Content of the RegattaPaymentDiscount
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    RegattaPaymentDiscountCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaPaymentDiscountParams'
 *        - type: object
 *          required:
 *            - Name
 *            - Value
 *
 *  @swagger
 *  definitions:
 *    RegattaPaymentDiscountQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the RegattaPaymentDiscount
 *              type: string
 *        - $ref: '#/definitions/RegattaPaymentDiscountParams'
 *
 *  @swagger
 *  definitions:
 *    RegattaPaymentDiscountUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaPaymentDiscountQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    RegattaPaymentDiscount:
 *      allOf:
 *        - $ref: '#/definitions/RegattaPaymentDiscountCreateParams'
 *        - $ref: '#/definitions/RegattaPaymentDiscountUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      RegattaPaymentDiscount:
 *        allOf:
 *          - $ref: '#/definitions/RegattaPaymentDiscount'
 *          - type: object
 *            properties:
 *              RegattaPayment:
 *                description: RegattaPayment of the RegattaPaymentDiscount
 *                $ref: '#/components/schemas/RegattaPayment'
 */

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

export type $Params = {
  Content: null | string;
  Name: string;
  Used: boolean;
  Value: number;
};

export type $CreateParams = $Params;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$Params>;

export type $Associations = {
  RegattaPayment?: $Model<'RegattaPayment'>;
};

export type $ModelParams = $Associations & $CreateParams & {
  id: string;
};

type $Fields = $Params & {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  Content: {
    allowNull: true,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
  Name: {
    allowNull: false,
    type: Sequelize.STRING,
    unique: true,
    validate: {
      notEmpty: true,
    },
  },
  Used: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  Value: {
    allowNull: false,
    type: Sequelize.INTEGER.UNSIGNED,
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'RegattaPaymentDiscount'> => {
  const RegattaPaymentDiscount = stack.define(
    'RegattaPaymentDiscount',
    fields(Sequelize),
    {
      tableName: 'RegattaPaymentDiscounts',
    },
  );

  RegattaPaymentDiscount.associate = (models: $ModelClasses) => {
    models.RegattaPaymentDiscount.hasOne(
      models.RegattaPayment,
      {
        as: 'RegattaPayment',
        constraints: false,
        foreignKey: 'RegattaPaymentDiscountId',
      },
    );
  };

  RegattaPaymentDiscount.addScope(
    'defaultScope',
    {
      order: [['createdAt', 'ASC']],
    },
  );

  return RegattaPaymentDiscount;
});
